import "whatwg-fetch";
const env = process.env;

const getGrowplan = data => {
  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/ag_growplans/getGrowplan?access_token=${data.apitoken}&growplan_id=${data.growplan_id}&env=${env.VUE_APP_env}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
};

const getPlantContainerTypes = apiToken => {
  return fetch(
    `${env.VUE_APP_trimaster}/api/v1/ag_growplans/plantcontainerTypes?access_token=${apiToken}&env=${env.VUE_APP_env}`,
    {
      method: "GET",
      headers: {
        Accept: "application/json"
      }
    }
  );
};

export default {
  getGrowplan,
  getPlantContainerTypes,
};
